module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "login-content"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "header-item",
    class: {
      active: _vm.showLogin
    },
    on: {
      "click": _vm.showLoginfunc
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("用户登录")])]), _vm._v(" "), _c('div', {
    staticClass: "header-item",
    class: {
      active: !_vm.showLogin
    },
    on: {
      "click": _vm.hideLoginFunc
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("APP下载")])])]), _vm._v(" "), _c('div', {
    staticClass: "login-body"
  }, [(_vm.showLogin) ? _c('div', {
    staticClass: "login-main"
  }, [_c('div', {
    staticClass: "input-wrapper"
  }, [_c('div', {
    staticClass: "input-phone",
    class: {
      warn: _vm.telTip
    }
  }, [(_vm.telTip) ? _c('div', {
    staticClass: "tip"
  }, [_vm._v(_vm._s(_vm.telTip))]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "text iconfont icon-shouji"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userData.userMobile),
      expression: "userData.userMobile"
    }],
    staticClass: "input",
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "placeholder": "请输入手机号码",
      "maxlength": "11"
    },
    domProps: {
      "value": (_vm.userData.userMobile)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.userData.userMobile = $event.target.value
      }, _vm.userMobileIpt],
      "blur": _vm.checkTel
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-password",
    class: {
      warn: _vm.passwordTip
    }
  }, [(_vm.passwordTip) ? _c('div', {
    staticClass: "tip"
  }, [_vm._v(_vm._s(_vm.passwordTip))]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "text iconfont icon-mima"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userData.userPWD),
      expression: "userData.userPWD"
    }],
    staticClass: "input",
    attrs: {
      "autocomplete": "off",
      "type": "password",
      "maxlength": "16",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.userData.userPWD)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.userData.userPWD = $event.target.value
      }, _vm.userPWDIpt],
      "blur": _vm.checkPWD,
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.loginMethod($event)
      }
    }
  })]), _vm._v(" "), (_vm.showPicCode) ? _c('div', {
    staticClass: "input-imgCode"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userData.picCode),
      expression: "userData.picCode"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "请输入图形验证码"
    },
    domProps: {
      "value": (_vm.userData.picCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userData.picCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.imgCode,
      "alt": "picCode"
    },
    on: {
      "click": _vm.getVerifyCodeMethod
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tools-wrapper"
  }, [_c('div', {
    staticClass: "forget"
  }, [_c('router-link', {
    attrs: {
      "to": "/forgotPasswordPage"
    }
  }, [_vm._v("忘记密码?")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "btn-wrapper"
  }, [_c('button', {
    staticClass: "button button-blue button-block",
    on: {
      "click": _vm.loginMethod
    }
  }, [_vm._v("登录")])]), _vm._v(" "), _c('div', {
    staticClass: "register-wrapper"
  }, [_vm._v("\r\n          没有账号?\r\n          "), _c('router-link', {
    staticClass: "text",
    attrs: {
      "to": "/registerPage"
    }
  }, [_vm._v("立即注册>>")])], 1)]) : _vm._e(), _vm._v(" "), (!_vm.showLogin) ? _c('div', {
    staticClass: "download-main"
  }, [_c('ts-image', {
    attrs: {
      "src": "/static/images/qrcode/app.png",
      "width": "300",
      "height": "300",
      "canView": false,
      "disabledHover": ""
    }
  })], 1) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-dc155728"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/login.vue
// module id = 861
// module chunks = 39